export const ADMIN_TRANSLATION_NAMESPACE = "admin";
